import React from 'react';
import { Button, Modal } from '@mairistem/composants';

interface ConfirmationModalProps {
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmationModal = ({ onClose, onConfirm }: ConfirmationModalProps) => (
  <Modal
    open
    size="small"
    closeOnDimmerClick
    closeOnDocumentClick
    closeOnEscape
    onClose={onClose}
  >
    <Modal.Header>
      Les modifications n&apos;ont pas été enregistrées
    </Modal.Header>
    <Modal.Content>
      <p>Êtes-vous sûr de vouloir continuer ?</p>
    </Modal.Content>
    <Modal.Actions>
      <Button
        basic
        size="small"
        icon="location arrow"
        content="Continuer"
        onClick={onConfirm}
        data-testid="confirmation-modal-cancel"
      />
      <Button
        primary
        icon="map marker alternate"
        content="Rester sur cette page"
        onClick={onClose}
        data-testid="confirmation-modal-confirm"
      />
    </Modal.Actions>
  </Modal>
);

export default ConfirmationModal;
